import { createContext, useContext } from 'react';

const OfflineContext = createContext();

export const useOfflineContext = () => useContext(OfflineContext);

export default OfflineContext;
